// Endless board hidden loot: 1% per card for a boost or pack (mutually exclusive with foil).

import {
    BOOST_INVENTORY_ITEM_IDS,
    INVENTORY_ITEM_IDS,
    isBoostInventoryItemId,
} from "./inventory";

export const HIDDEN_LOOT_CHANCE = 0.01;
export const HIDDEN_LOOT_BOOST_SHARE = 0.7;

export const LS_HIDDEN_BOOST_DISCOVERY_SEEN_KEY =
    "mmu_seen_hidden_boost_discovery_v1";
export const LS_HIDDEN_PACK_DISCOVERY_SEEN_KEY =
    "mmu_seen_hidden_pack_discovery_v1";

export const HIDDEN_BOOST_DISCOVERY_TITLE = "You've found a hidden Boost!";
export const HIDDEN_BOOST_DISCOVERY_MESSAGE =
    "When a card shows a boost badge, that boost is added to your Profile inventory. Use it during a run from the boost bar.";

export const HIDDEN_PACK_DISCOVERY_TITLE = "You've found a hidden Pack!";
export const HIDDEN_PACK_DISCOVERY_MESSAGE =
    "When a card shows a pack badge, that Corgi Pack is added to your Profile inventory. Open it from Profile when you're ready.";

export function hasSeenHiddenBoostDiscovery() {
    try {
        return (
            window.localStorage.getItem(LS_HIDDEN_BOOST_DISCOVERY_SEEN_KEY) ===
            "1"
        );
    } catch {
        return false;
    }
}

export function markHiddenBoostDiscoverySeen() {
    try {
        window.localStorage.setItem(LS_HIDDEN_BOOST_DISCOVERY_SEEN_KEY, "1");
    } catch {
        // ignore localStorage failures
    }
}

export function hasSeenHiddenPackDiscovery() {
    try {
        return (
            window.localStorage.getItem(LS_HIDDEN_PACK_DISCOVERY_SEEN_KEY) ===
            "1"
        );
    } catch {
        return false;
    }
}

export function markHiddenPackDiscoverySeen() {
    try {
        window.localStorage.setItem(LS_HIDDEN_PACK_DISCOVERY_SEEN_KEY, "1");
    } catch {
        // ignore localStorage failures
    }
}

export function isHiddenPackKind(kind) {
    return kind === INVENTORY_ITEM_IDS.CORGI_PACK;
}

export function isHiddenBoostKind(kind) {
    return isBoostInventoryItemId(kind);
}

/**
 * Roll boost (equal Reveal / Shield / Freeze) or pack when hidden loot hits.
 */
export function rollHiddenLootKind(random = Math.random) {
    if (random() >= HIDDEN_LOOT_BOOST_SHARE) {
        return INVENTORY_ITEM_IDS.CORGI_PACK;
    }

    const index = Math.floor(random() * BOOST_INVENTORY_ITEM_IDS.length);
    return BOOST_INVENTORY_ITEM_IDS[index];
}

export function applyHiddenBoardLootToCard(
    card,
    { random = Math.random } = {}
) {
    if (!card || card.isFoil) {
        return {
            ...card,
            hiddenLootKind: null,
        };
    }

    if (random() >= HIDDEN_LOOT_CHANCE) {
        return {
            ...card,
            hiddenLootKind: null,
        };
    }

    return {
        ...card,
        hiddenLootKind: rollHiddenLootKind(random),
    };
}

export function applyHiddenBoardLootToCards(
    cards = [],
    { allowHiddenLoot = true, random = Math.random } = {}
) {
    if (!allowHiddenLoot) {
        return (Array.isArray(cards) ? cards : []).map((card) => ({
            ...card,
            hiddenLootKind: null,
        }));
    }

    return (Array.isArray(cards) ? cards : []).map((card) =>
        applyHiddenBoardLootToCard(card, { random })
    );
}

export function getHiddenLootDiscoveryCopy(kind) {
    if (kind === "pack") {
        return {
            title: HIDDEN_PACK_DISCOVERY_TITLE,
            message: HIDDEN_PACK_DISCOVERY_MESSAGE,
        };
    }

    return {
        title: HIDDEN_BOOST_DISCOVERY_TITLE,
        message: HIDDEN_BOOST_DISCOVERY_MESSAGE,
    };
}
